/**
 * Адрес страницы ресурса по паре kind/id (контракты §3): единственное место, где тип
 * ресурса превращается в адрес. Строковый id кодируется целиком.
 */

import type { ResourceKind, ResourceRef } from '@/api/workspaceTypes';

export const RESOURCE_BASE_PATH: Record<ResourceKind, string> = {
	service: '/service-catalog/services',
	sql_database: '/data-storages/databases',
	s3_bucket: '/data-storages/s3-buckets',
	kafka_instance: '/data-storages/kafka/instances',
	nosql_database: '/data-storages/nosql-databases',
};

export function resourcePath(resource: ResourceRef): string {
	return `${RESOURCE_BASE_PATH[resource.kind]}/${encodeURIComponent(resource.id)}`;
}

/** Тип узла карты данных для вида ресурса (обратное к mapNodeResource карты) */
const MAP_NODE_TYPE: Record<ResourceKind, string> = {
	service: 'resource',
	sql_database: 'sql_db_database',
	s3_bucket: 's3_object_store',
	kafka_instance: 'kafka_instance',
	nosql_database: 'nosql_db_database',
};

/** Карта данных с выбранным узлом ресурса (параметр node — «тип/id», как у карты) */
export function resourceMapPath(resource: ResourceRef): string {
	const params = new URLSearchParams({ node: `${MAP_NODE_TYPE[resource.kind]}/${resource.id}` });
	return `/data-map?${params.toString()}`;
}
